import * as yup from 'yup';

// export const claimNumber = yup.string().matches(/^[0-9]{9}$/, 'Tax ID Must be 9 digits');

export const claimNumber = yup.string().matches(/^[0-9]{9}-\d{4}$/, 'Claim Number must be 9 and 4');
